<template>
  <div>
    <agile-table
      :dataType="'deliveryTemplates'"
      :data="deliveryTemplates"
      :table-meta="tableMeta"
      :filter-meta="filterMeta"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      @rowAction="rowAction"
      @fieldAction="fieldAction" />
    <new-button v-if="displayCreateButton" @clicked="openDeliveryTemplateModal(0)" />
    <slideout-panel />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'
import DeliveryTemplateModal from '@/components/modals/DeliveryTemplateModal'
import AgileTable from '@/components/table/AgileTable'

export default {
  components: {
    NewButton,
    DeliveryTemplateModal,
    AgileTable
  },
  props: {
    displayCreateButton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      tableMeta: {
        headingIcon: 'fa-truck'
      },

      filterMeta: [{
        fieldId: 'name',
        type: 'string',
        label: 'Namn'
      }],

      columnMeta: {
        hasActions: true,
        items: [{
          fieldId: 'name',
          label: 'Namn'
        }, {
          fieldId: 'dateCreated',
          label: 'Datum skapad',
          dataType: 'date'
        }, {
          fieldId: 'numberOfItems',
          label: 'Antal insatser'
        }]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: 'Ändra',
          action: 'updateDeliveryTemplate',
          iconClass: 'fal fa-pen'
        }]
      }
    }
  },
  watch: {
    'deliveryTemplates.filter': {
      handler () {
        this.deliveryTemplates.currentPage = 1
        this.getListData()
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      deliveryTemplates: state => state.deliveryTemplates.all
    })
  },
  methods: {
    ...mapActions('deliveryTemplates', ['initialize', 'getListData', 'delete']),
    rowAction (action, deliveryTemplate) {
      switch (action) {
        case 'updateDeliveryTemplate':
          this.openDeliveryTemplateModal(deliveryTemplate.deliveryTemplateId)
          break
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },
    fieldAction (action, deliveryTemplate) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },
    openDeliveryTemplateModal (deliveryTemplateId) {
      this.$panel(DeliveryTemplateModal, { deliveryTemplateId })
    }
  },
  created () {
    this.initialize()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Admin/SuperAdmin/DeliveryTemplatesPage.vue